import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const CashPaymentSchema = z.object({
  company: z.string().min(3),
  order: z.string(),
}); 

export type CashPaymentSchemaType = z.infer<typeof CashPaymentSchema>;

export async function payWithCashService(formData: CashPaymentSchemaType) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/payments/cash`,
      formData
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}

